import { IBundleConfiguration, IEventBundleConfiguration } from "../models/configuration/bundles/IBundles";
import { deepEqual } from "./deepEqual";

export const hasDocumentBundlingChanges = (
    current: IBundleConfiguration,
    persisted?: IBundleConfiguration | null
): boolean => {
    if (!persisted) return true;
    return !deepEqual(current, persisted);
};

export const hasEventBundlingChanges = (
    current: IEventBundleConfiguration,
    persisted?: IEventBundleConfiguration | null
): boolean => {
    if (!persisted) return true;
    return !deepEqual(current, persisted);
};
